import { useEffect, useRef } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { imgSrc } from "../../lib/api";

export const GalleryViewer = ({ photos, index, setIndex }) => {
  const startX = useRef(null);
  const n = photos.length;
  const go = (d) => setIndex((i) => (i + d + n) % n);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
      if (e.key === "Escape") setIndex(null);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  });

  const onEnd = (e) => {
    if (startX.current === null) return;
    const dx = e.changedTouches[0].clientX - startX.current;
    startX.current = null;
    if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1);
  };
  const p = photos[index];
  const arrow = "absolute top-1/2 -translate-y-1/2 z-10 p-2 rounded-full bg-black/50 text-lime hover:bg-[#00d436] hover:text-black transition-colors";

  return (
    <div className="fixed inset-0 z-[70] bg-black/95 flex items-center justify-center" data-testid="gallery-lightbox"
      onClick={() => setIndex(null)} onTouchStart={(e) => { startX.current = e.touches[0].clientX; }} onTouchEnd={onEnd}>
      <button className="absolute top-5 right-5 z-10 text-white hover:text-lime" data-testid="gallery-lightbox-close" aria-label="Close"><X className="w-8 h-8" /></button>
      <button onClick={(e) => { e.stopPropagation(); go(-1); }} className={`${arrow} left-3`} data-testid="gallery-lightbox-prev" aria-label="Previous"><ChevronLeft className="w-7 h-7" /></button>
      <img key={p.id} src={imgSrc(p.image_url)} alt={p.caption} onClick={(e) => e.stopPropagation()}
        className="max-h-[88vh] max-w-[92vw] object-contain animate-in fade-in duration-300 select-none" draggable={false} data-testid="gallery-lightbox-image" />
      <button onClick={(e) => { e.stopPropagation(); go(1); }} className={`${arrow} right-3`} data-testid="gallery-lightbox-next" aria-label="Next"><ChevronRight className="w-7 h-7" /></button>
      <span className="absolute bottom-6 left-1/2 -translate-x-1/2 font-cond tracking-widest text-lime text-sm" data-testid="gallery-lightbox-counter">{index + 1} / {n}</span>
    </div>
  );
};
